{
  "chart": {
    "empty": {
      "description": "Inga data tillgängliga för denna period.",
      "title": "Inga data hittades"
    }
  },
  "date_picker": {
    "all_time": "Alltid",
    "confirm": "Bekräfta",
    "current_quarter": "Innevarande kvartal",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Senaste {days} dagarna",
    "last_n_months": "Senaste {months} månaderna",
    "last_quarter": "Föregående kvartal",
    "last_year": "Förra året",
    "lifetime": "Hela perioden",
    "this_year": "I år",
    "today": "Idag"
  },
  "document_viewer": {
    "sidebar_heading": "Innehållsöversikt"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "error": {
    "title": "Ett fel har inträffat."
  },
  "factor_indicator": {
    "average": "Genomsnitt",
    "bad": "Kritiskt",
    "excellent": "Utmärkt",
    "good": "Bra"
  },
  "gauge_chart": {
    "empty": {
      "title": "Ingen data tillgänglig",
      "tooltip": "Din motståndskraftspoäng beräknas"
    }
  },
  "locale": {
    "current": "Svenska",
    "danish": "Danska",
    "dutch": "Nederlands",
    "english": "Engelska",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Tyska",
    "norwegian": "Norska",
    "polish": "Polska",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Fortsätt med {provider}"
  },
  "search": {
    "no_options": "Inga tillgängliga alternativ.",
    "no_results": "Inga resultat hittades.",
    "placeholder": "Sök..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Stäng förhandsgranskning",
      "open": "Expandera förhandsgranskning"
    }
  },
  "video_player": {
    "captions": "Undertexter",
    "captions_off": "Av",
    "normal_speed": "Normal",
    "playback_speed": "Uppspelningshastighet"
  }
}
